export const GET_MENU = "GET_MENU";
export const GET_MENU_SUCCESS = "GET_MENU_SUCCESS";
export const GET_MENU_FAILURE = "GET_MENU_FAILURE";
export const GET_BADGE_MENU = "GET_BADGE_MENU";
export const GET_BADGE_MENU_SUCCESS = "GET_BADGE_MENU_SUCCESS";
export const GET_BADGE_MENU_FAILURE = "GET_BADGE_MENU_FAILURE";
